import React from 'react';
import {
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend,
} from 'recharts';
import type { H2HDimension } from '../../types/headToHead';

interface Props {
  dimensions: H2HDimension[];
  nameA: string;
  nameB: string;
  colorA?: string;
  colorB?: string;
}

export function H2HRadarChart({ dimensions: allDimensions, nameA, nameB, colorA = '#4caf50', colorB = '#2196f3' }: Props) {
  // Las dimensiones de reloj se excluyen del radar: con cobertura parcial (un
  // jugador sin datos) un radar con 0 mentiría visualmente. Se muestran solo
  // como filas en la lista de dimensiones.
  const dimensions = allDimensions.filter((d) => !d.coverage);
  const data = dimensions.map((d) => {
    const max = Math.max(d.a, d.b);
    return {
      label: d.label,
      a: max > 0 ? (d.a / max) * 100 : 0,
      b: max > 0 ? (d.b / max) * 100 : 0,
      rawA: d.a,
      rawB: d.b,
    };
  });

  return (
    <div style={{ width: '100%', height: 320 }}>
      <ResponsiveContainer>
        <RadarChart data={data}>
          <PolarGrid stroke="#333" />
          <PolarAngleAxis dataKey="label" tick={{ fill: '#aaa', fontSize: 12 }} />
          <PolarRadiusAxis tick={false} axisLine={false} />
          <Radar name={nameA} dataKey="a" stroke={colorA} fill={colorA} fillOpacity={0.3} />
          <Radar name={nameB} dataKey="b" stroke={colorB} fill={colorB} fillOpacity={0.3} />
          <Legend wrapperStyle={{ color: '#ddd' }} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
